import React from 'react';
import { useNavigate } from 'react-router-dom';


// `embedded` renders inline (inside the admin layout) instead of as a fixed full-screen overlay.
const PaymentSelector = ({ embedded = false }: { embedded?: boolean }) => {


  const navigate = useNavigate();
  const basePath = embedded ? '/adminSales' : '/lisualSales';

  const handleStripeLink = () => {
    navigate(`${basePath}/createStripeLink`);
  };

  const handleCreateCustomerBySalesTeam = () => {
    navigate(`${basePath}/createCustomer`);
  };




  return (
            <div className={embedded ? 'w-full' : 'w-full bg-red-600 py-3'}>

          <div className={embedded ? 'flex items-center justify-center' : 'fixed inset-0 bg-gray-400 bg-opacity-50 flex items-center justify-center z-50'}>
    
      
    
      <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-4xl mx-auto my-8">
        
        <h2 className="text-xl font-semibold mb-4">Configura el plan del cliente:</h2>
        {/*<p className="text-m font-semibold mb-4">Selecciona el tipo de pago: </p>*/}

    
        <div className="mb-4">
          <p className="text-m font-semibold mb-4">Completa los datos para poder enviar un enlace de Stripe. El cliente va a ser creado luego de la confirmación de pago.</p>

          
              <button
                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                type="submit"
                onClick={handleStripeLink}
              >
                Generar un enlace de pago de Stripe
              </button>


        </div>


        <div className="mb-4">
          <p className="text-m font-semibold mb-4">Creas un nuevo cliente colocando el monto del pago alternativo.</p>

          <button
            className="w-full bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
            onClick={handleCreateCustomerBySalesTeam}
          >
            Crear un cliente de pago alternativo
          </button>
        </div>

        <div className="mb-4">
          <p className="text-m font-semibold mb-4">Generar enlaces de pagos sin alta de cliente automatica</p>

          <a
            href="https://editor.lisual.com/pay/generar.html"
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-gray-700 hover:bg-gray-900 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Generador de enlaces de pagos
          </a>
        </div>
      </div>
    </div>
    </div>
  );
};

export default PaymentSelector;